import queryString from "query-string";

const stripProtocol = (url) => {
    return url.replace(/(^\w+:|^)\/\//, "");
};

const isMobile = () => {
    return document.body.clientWidth < 900;
};

const scrollToCard = (scroller, card) => {
    if (isMobile()) {
        return;
    }
    var cardHeight = card.clientHeight;
    var scrollerHeight = scroller.clientHeight;

    // var tmp = card.offsetTop - scrollerHeight / 2 + cardHeight / 2;
    var tmp = card.offsetTop - 20;
    scroller.scrollTo({ top: tmp, behavior: "smooth" });
};

const getSessionItem = (key) => {
    if (!key) {
        throw new Error("getSessionItem: 'key' can not be empty");
    }

    const item = sessionStorage.getItem(key);

    if (item !== null) {
        return JSON.parse(item);
    }

    return [];
};

const setSessionItem = (key, value) => {
    if (!key) {
        throw new Error("setSessionItem: 'key' can not be empty");
    }

    if (!value) {
        throw new Error("setSessionItem: 'value' can not be empty");
    }
    sessionStorage.setItem(key, JSON.stringify(value));
};

export { stripProtocol, scrollToCard, isMobile, getSessionItem, setSessionItem };
